import { Component, Inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import {
  ShiftInfoFormModel
} from 'app/field-shared/forms/shift-info-form/shift-info-form.component';
import { ToastrService } from 'core/toastr.service';

import { ShiftInput, UpdateShiftGQL } from 'generated/graphql';

/**
 * Format of data for the dialog
 */
export interface ShiftAddOrUpdateDialogData {
  shift: ShiftInfoFormModel;
  // We will use this for creating a shift
  entityTagId?: string;
}

@Component({
  selector: 'app-shift-add-or-update-dialog',
  templateUrl: './shift-add-or-update.dialog.html'
})
export class ShiftAddOrUpdateDialog  {
  shiftInfoControl = new UntypedFormControl();

  get isCreate() {
    return this.data?.shift?.id == null;
  }

  static open(dialog: MatDialog, config: MatDialogConfig<ShiftAddOrUpdateDialogData>) {
    return dialog.open(ShiftAddOrUpdateDialog, config);
  }

  constructor(
    public dialogRef: MatDialogRef<ShiftAddOrUpdateDialog>,
    private _updateShiftGQL: UpdateShiftGQL,
    private _toastrService: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: ShiftAddOrUpdateDialogData
  ) {
    this.shiftInfoControl.patchValue(data.shift);
  }


  close(data: any = null) {
    this.dialogRef.close(data);
  }

  onSaveClick() {
    if (!this.isCreate) {
      this._updateShiftGQL.mutate({
        input: {
          shiftId: this.data.shift.id,
          changes: this._makeShiftInputGQLInput()
        }
      }).subscribe((res) => {
        this._toastrService.success('Shift updated');
        this.close(res?.data.updateShift);
      });
    }
  }

  private _makeShiftInputGQLInput(): ShiftInput {
    const fv = this.shiftInfoControl.value as ShiftInfoFormModel;
    return {
      timezone: fv.timezone,
      shiftTimes: fv.shiftTimes
    };
  }
}
